import React from 'react';
//import Box from '@material-ui/core/Box';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import moment from 'moment';
import useLoadReport from '../hooks/useLoadReport';
//import PropTypes from 'prop-types';

import restApi from '../restApi';
import MapPrintReport from './MapPrintReport';
//import PropTypes from 'prop-types';
import NoDataDialog from './NoDataDialog';
import { reportReset } from '../actions/index';
import { useToasts } from 'react-toast-notifications';
import configuration from '../configuration';
import { AddressMap } from '../AddressMap';

const PrintTraceView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { viewName } = useParams();

  const data = React.useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    return {
      type: 'print',
      objectId: queryParams.get('object'),
      start: moment(queryParams.get('start')),
      end: moment(queryParams.get('end')),
      params: queryParams.get('params')
        ? JSON.parse(queryParams.get('params'))
        : null,
    };
  }, [location.search]);

  // const hasMissingParams = !data.objectId || !data.start || !data.end;

  const loadReport = useLoadReport(data, data.params);

  React.useEffect(() => {
    if (viewName === 'print') {
      loadReport.loadAsync().then(() => {
        // Report loaded successfully
      });
    }
  }, [loadReport, viewName]);

  const { addToast } = useToasts();

  const onConfirm = () => {
    history.goBack();
    dispatch(reportReset('print'));
  };
  const [addressMap, setAddressMap] = React.useState();
  const [disableButton, setDisableButton] = React.useState(true);

  const printReport = useSelector(state => state.report.print);
  const printReportOptions = useSelector(state => state.report.options);
  //  const userData = useSelector(state => state.user);
  const errorDialog = printReport && printReport.status === 'nodata';
  const loading =
    printReport.status === 'loading' || printReport.status === 'nodata';

  React.useEffect(() => {
    if (configuration().geocoding.disable) {
      return;
    }
    if (!loading) {
      const coords = printReport.map.geometry.coordinates;

      restApi.startReverseGeocodingAsync(coords).then(resp => {
        return restApi.getReverseGeocodingAsync(resp.data.trackingId);
      }).then(resp => {
        if (resp.ok) {
          setAddressMap(new AddressMap(resp.data.addressList.map((item, index) => [coords[index], item])));
          setDisableButton(false);
        } else {
          addToast('Адресите не могат да се изчислят.', {
            appearance: 'error',
          });
          setDisableButton(false);
        }
      });
    }
  }, [addToast, loading, printReport]);

  React.useEffect(() => {
    if (!addressMap && printReport.map) {
      setAddressMap(new AddressMap(printReport.map.geometry.coordinates.map((item) => [item, '...'])));
    }
  }, [addressMap, printReport.map]);

  React.useEffect(() => {
    if (loading) {
      setAddressMap(null);
      setDisableButton(true);
    }
  }, [loading]);

  // const printType = React.useMemo(() => {
  //   if (printReport && printReport.reportIndex != null) {
  //     return printReportTypes[printReport.reportIndex].value;
  //   }
  // }, [printReport]);

  return (
    <React.Fragment>
      {errorDialog && (
        <NoDataDialog
          open={true}
          onClose={onConfirm}
          objectName={printReport.objectName}
          startDate={printReport.start}
          endDate={printReport.end}
        />
      )}
      <MapPrintReport
        object={printReport}
        loading={loading}
        addressMap={addressMap}
        disableButton={disableButton}
        options={{ print: printReportOptions }}
        printType={data.params?.type}
      />
    </React.Fragment>
  );
};

export default PrintTraceView;
